/* ============================================================================
   GLORY INSURANCE MODAL — LOGIC
   
   Iskače kad kupac doda parfem u korpu, nudi mu da doda i osiguranje paketa.
   
   Pravila prikazivanja (redom — ako bilo koje fail-uje, modal ne iskače):
   1. Osiguranje već u korpi → SKIP
   2. Dodati item JE osiguranje → SKIP (ne pita za osiguranje pri dodavanju osiguranja)
   3. localStorage 'glory_insurance_declined' === '1' → SKIP (rekao "Ne, hvala")
   4. sessionStorage 'glory_insurance_seen' === '1' → SKIP (već video u ovoj sesiji)
      ⤷ IZUZETAK: ako je korpa BILA PRAZNA pre dodavanja → reset session flag i prikaži opet
        (kupac je obrisao sve i počeo nov shopping — zaslužuje novu šansu)
   
   Ako sve prođe → prikaži modal, postavi sessionStorage flag.
   
   Akcije:
   - "Da, dodaj zaštitu" → AJAX add osiguranje, otvori cart drawer, set sessionFlag
   - "Ne, hvala" → set localStorage flag (trajno) + sessionStorage flag, otvori drawer
   - "X" / klik na overlay → samo session flag, otvori drawer
   
   NAPOMENA: Overlay logika ide ovde (inline preko JS-a), NE u CSS-u.
   Isti pattern kao glory-bih-checkout-modal.
   ============================================================================ */

(function () {
  'use strict';

  const INSURANCE_HANDLE = 'osiguranje-posiljke';
  const STORAGE_DECLINED = 'glory_insurance_declined';
  const STORAGE_SEEN = 'glory_insurance_seen';
  const OVERLAY_ID = 'GloryInsuranceModalOverlay';

  let modal = null;
  let overlay = null;
  let variantId = null;
  let isInitialized = false;
  let lastTrigger = null;
  let cartCountBeforeAdd = null;

  // ============== INIT ==============
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    modal = document.getElementById('GloryInsuranceModal');
    if (!modal || isInitialized) return;

    variantId = modal.getAttribute('data-variant-id');
    if (!variantId) {
      console.warn('[Glory Insurance] Variant ID nije postavljen.');
      return;
    }

    // Hook na Shopify Pub/Sub cart-update event (Dawn + custom drawer)
    if (window.Shopify && window.PUB_SUB_EVENTS && window.subscribe) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }

    // Fallback hook: presretni AJAX add to cart fetch poziv
    interceptAddToCart();

    // Bind dugmiće u modalu
    const closeBtn = modal.querySelector('[data-glory-insurance-close]');
    const acceptBtn = modal.querySelector('[data-glory-insurance-accept]');
    const declineBtn = modal.querySelector('[data-glory-insurance-decline]');

    if (closeBtn) closeBtn.addEventListener('click', handleClose);
    if (acceptBtn) acceptBtn.addEventListener('click', handleAccept);
    if (declineBtn) declineBtn.addEventListener('click', handleDecline);

    // ESC zatvara modal
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        handleClose();
      }
    });

    isInitialized = true;
  }

  // ============== EVENT HANDLERS ==============

  /**
   * Hook na Shopify cart-update pub/sub event
   * Source: 'product-form' znači da je upravo dodato u korpu
   */
  function handleCartUpdate(event) {
    if (!event || !event.source) return;

    // Reaguj samo na product-form / drawer add events
    const validSources = ['product-form', 'cart-items', 'cart-drawer'];
    if (!validSources.includes(event.source)) return;

    // Ako je dodato osiguranje samo, ne nudi opet
    if (event.productVariantId && String(event.productVariantId) === String(variantId)) {
      return;
    }

    maybeShowModal(event.cartData);
  }

  /**
   * Fallback: presretni fetch /cart/add.js pozive
   * Za slučaj da custom drawer ne emituje pub/sub event
   * 
   * Pre nego što fetch krene, snimimo trenutni cart count — koristimo
   * to za detekciju "fresh shopping flow" (korpa bila prazna).
   */
  function interceptAddToCart() {
    const originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function (...args) {
      const url = args[0];
      const isAddToCart = typeof url === 'string' && url.includes('/cart/add');

      if (isAddToCart) {
        // Snimi cart count PRE dodavanja (fire-and-forget, ne blokira fetch)
        captureCartCountBeforeAdd();
      }

      const result = originalFetch.apply(this, args);

      if (isAddToCart) {
        result.then(function (response) {
          if (!response.ok) return;
          // Sačekaj da Shopify završi update, onda fetchuj cart
          setTimeout(checkCartAfterAdd, 250);
        }).catch(function () {});
      }

      return result;
    };
  }

  /**
   * Snimi koliko stavki je u korpi PRE add-to-cart-a.
   * Ako je 0, znamo da je ovo fresh shopping flow.
   */
  function captureCartCountBeforeAdd() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCountBeforeAdd = cart.item_count || 0;
      })
      .catch(function () {
        cartCountBeforeAdd = null;
      });
  }

  function checkCartAfterAdd() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Proveri da li je upravo dodato osiguranje (ako da, ne nudi opet)
        if (cart.items && cart.items.length > 0) {
          const lastItem = cart.items[cart.items.length - 1];
          if (lastItem.handle === INSURANCE_HANDLE) return;
        }
        maybeShowModal(cart);
      })
      .catch(function () {});
  }

  /**
   * Glavna logika: da li smemo da prikažemo modal?
   */
  function maybeShowModal(cartData) {
    // 1. Da li je osiguranje već u korpi?
    if (cartData && cartData.items && Array.isArray(cartData.items)) {
      const hasInsurance = cartData.items.some(function (item) {
        return item.handle === INSURANCE_HANDLE ||
               String(item.variant_id) === String(variantId) ||
               String(item.id) === String(variantId);
      });
      if (hasInsurance) return;
    }

    // 2. Da li je trajno odbio?
    try {
      if (localStorage.getItem(STORAGE_DECLINED) === '1') return;
    } catch (e) { /* localStorage nedostupan, nastavi */ }

    // 3. Da li je već video u ovoj sesiji?
    //    IZUZETAK: ako je korpa BILA PRAZNA pre dodavanja, kupac je obrisao
    //    sve i krenuo nov shopping flow → resetuj session flag i prikaži opet.
    let sessionSeen = false;
    try {
      sessionSeen = sessionStorage.getItem(STORAGE_SEEN) === '1';
    } catch (e) { /* sessionStorage nedostupan */ }

    if (sessionSeen) {
      const isFreshShoppingFlow = (cartCountBeforeAdd === 0);
      if (isFreshShoppingFlow) {
        // Resetuj flag — kupac je obrisao korpu i kreće ispočetka
        try { sessionStorage.removeItem(STORAGE_SEEN); } catch (e) {}
      } else {
        // Već je video u istoj sesiji, nije fresh start — preskoči
        return;
      }
    }

    // Sve prošlo — prikaži modal
    showModal();
  }

  // ============== MODAL OPEN/CLOSE ==============

  function showModal() {
    if (!modal) return;

    // Markiraj kao "videno u ovoj sesiji" odmah
    try { sessionStorage.setItem(STORAGE_SEEN, '1'); } catch (e) {}

    // Sačuvaj trenutno fokusiran element za vraćanje fokusa
    lastTrigger = document.activeElement;

    // Ako je drawer otvoren, zatvori ga privremeno (modal ima prioritet)
    closeCartDrawerIfOpen();

    // Postavi overlay inline (Dawn forsira display:none preko CSS-a)
    createOverlay();

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');

    // Trigger reflow pa anim. radi
    void modal.offsetWidth;

    requestAnimationFrame(function () {
      modal.classList.add('is-active');
    });

    document.body.style.overflow = 'hidden';

    // Fokus na primary CTA
    setTimeout(function () {
      const acceptBtn = modal.querySelector('[data-glory-insurance-accept]');
      if (acceptBtn) acceptBtn.focus();
    }, 320);
  }

  function hideModal() {
    if (!modal) return;

    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');

    setTimeout(function () {
      modal.hidden = true;
      removeOverlay();
      document.body.style.overflow = '';
    }, 300);

    // Vrati fokus
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      try { lastTrigger.focus(); } catch (e) {}
    }
  }

  // ============== OVERLAY (inline za Dawn override) ==============

  function createOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = [
      'position: fixed !important',
      'top: 0 !important',
      'left: 0 !important',
      'right: 0 !important',
      'bottom: 0 !important',
      'width: 100% !important',
      'height: 100% !important',
      'background: rgba(0, 0, 0, 0.55) !important',
      'backdrop-filter: blur(2px) !important',
      '-webkit-backdrop-filter: blur(2px) !important',
      'z-index: 99998 !important',
      'opacity: 0',
      'transition: opacity 0.3s ease',
      'display: block !important'
    ].join(';');

    overlay.addEventListener('click', handleClose);

    document.body.appendChild(overlay);

    // Modal iznad overlay-a
    modal.style.zIndex = '99999';

    requestAnimationFrame(function () {
      overlay.style.opacity = '1';
    });
  }

  function removeOverlay() {
    if (!overlay) return;
    overlay.style.opacity = '0';
    const refOverlay = overlay;
    overlay = null;
    setTimeout(function () {
      if (refOverlay && refOverlay.parentNode) {
        refOverlay.parentNode.removeChild(refOverlay);
      }
    }, 300);
  }

  // ============== ACTIONS ==============

  function handleAccept() {
    const acceptBtn = modal.querySelector('[data-glory-insurance-accept]');
    if (!acceptBtn || acceptBtn.classList.contains('is-loading')) return;

    acceptBtn.classList.add('is-loading');

    const formData = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        // Refresh cart sections (Dawn theme pattern)
        return refreshCartSections();
      })
      .then(function () {
        acceptBtn.classList.remove('is-loading');
        hideModal();
        setTimeout(openCartDrawer, 320);
      })
      .catch(function (err) {
        console.error('[Glory Insurance] Greška pri dodavanju:', err);
        acceptBtn.classList.remove('is-loading');
        hideModal();
        setTimeout(openCartDrawer, 320);
      });
  }

  function handleDecline() {
    // Trajno markiraj kao odbijeno
    try { localStorage.setItem(STORAGE_DECLINED, '1'); } catch (e) {}
    hideModal();
    setTimeout(openCartDrawer, 320);
  }

  function handleClose() {
    // Samo zatvori — sessionStorage flag je već postavljen
    hideModal();
    setTimeout(openCartDrawer, 320);
  }

  // ============== CART DRAWER HELPERS ==============

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    // Dawn cart-drawer pattern
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('active');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
    }
  }

  function closeCartDrawerIfOpen() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.classList.contains('active') || drawer.classList.contains('is-empty') === false) {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.classList.remove('active');
        drawer.setAttribute('inert', '');
        drawer.setAttribute('aria-hidden', 'true');
      }
    }
  }

  /**
   * Re-fetch cart sections da Dawn drawer prikaže nov sadržaj
   */
  function refreshCartSections() {
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const sectionUrl = '/?sections=' + sections.join(',');

    return fetch(sectionUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        sections.forEach(function (section) {
          if (!data[section]) return;
          const el = document.getElementById(section === 'cart-drawer' ? 'CartDrawer' : 'cart-icon-bubble');
          if (!el) return;
          const parsed = new DOMParser().parseFromString(data[section], 'text/html');
          const replacement = parsed.querySelector(section === 'cart-drawer' ? '#CartDrawer' : '#cart-icon-bubble');
          if (replacement) el.innerHTML = replacement.innerHTML;
        });

        // Trigger Shopify pub/sub za druge listenere
        if (window.PUB_SUB_EVENTS && window.publish) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'glory-insurance-modal',
                cartData: cart
              });
            })
            .catch(function () {});
        }
      })
      .catch(function () { /* tihi fail */ });
  }
})();